import React, { Component } from "react";
import ReactDOM from 'react-dom';
import axios from "axios";
import { getErrorsMessage, getSuccessMessage } from '../utils.js';
import { LangContext } from "../LangContext.jsx";
class PendingDocumentsActions extends Component {
    static contextType = LangContext;
    constructor(props) {
        super();
        this.state = {
        };

    }

    cancelPeriod = ()=>{
        const { lang } = this.context; 
        swal.fire({ 
            text: "¿Estás seguro que deseas borrar el período del documento?",
            showCancelButton: true,
            icon: "question",
            buttonsStyling: false,
            confirmButtonText:  lang.get('messages.continuar'),
            cancelButtonText:  lang.get('messages.cancelar'),
            customClass: {
                confirmButton: "btn font-weight-bold btn-primary",
                cancelButton: "btn font-weight-bold btn-secondary"
            }
        }).then((result) => {
            if (result.isConfirmed) {
                axios.post('/api/documents/'+this.props.document.id+'/cancel/'+this.props.person_provider_id).then(res=>{
                    swal.fire({
                        text: "Se ha cancelado el periodo del documento",
                        icon: "success",
                        buttonsStyling: false,
                        confirmButtonText:lang.get('messages.aceptar'),
                        customClass: {
                            confirmButton: "btn font-weight-bold btn-primary"
                        },
                        timer: 3000
                    }).then(function(result) {
                        location.reload()
                    });
                })
            }
        });
    }
    async componentDidMount() {

    }

    render() {
        const { lang } = this.context;
        const canUploadDocument = this.props.permissions?.documents_actions?.includes('all') || this.props.permissions?.documents_actions?.includes('load');
        const canDeleteDocumentRequest = this.props.user_mode == 'client' && (this.props.permissions?.documents_actions?.includes('all') || this.props.permissions?.documents_actions?.includes('delete_document_request'));
        const canShowActions = canUploadDocument || canDeleteDocumentRequest;

        if (!canShowActions) {
            return null;
        }

        return (
            <div className="d-flex justify-content-end">
                <div className="dropdown dropdown-inline">
                    <a href="#" class="btn btn-fixed-height btn-primary font-weight-bolder font-size-sm px-5" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        {lang.get('messages.acciones')}
                        &nbsp;&nbsp;
                        <i class="flaticon2-down icon-sm"></i>
                    </a>
                    <div className="dropdown-menu dropdown-menu-lg dropdown-menu-right p-0 m-0 rounded-lg"  >
                        <ul className="navi navi-hover">
                            {canUploadDocument && (
                            <li className="navi-item"> 
                                <a href={"/document_dossier/" + this.props.person_provider_id +"/new_file/" + this.props.document.id} class="navi-link py-4">
                                    <span className="navi-icon mr-5 text-center">
                                        <span className="flaticon2-file-1 text-primary icon-md"></span>
                                    </span> 
                                    <span className="navi-text text-secondary">{lang.get('messages.subir_documento')}</span>
                                    <span className="navi-icon pull-right">
                                        <button className="btn btn-icon btn-light btn-xs bg-white">
                                            <i className="flaticon2-right-arrow text-primary icon-sm"></i>
                                        </button>
                                    </span>
                                </a>
                            </li>
                            )}
                            {canDeleteDocumentRequest && (
                            <>
                                <li className="navi-item">
                                <a onClick={  () => this.cancelPeriod() } class="navi-link py-4">
                                    <span className="navi-icon mr-5 text-center">
                                        <span className="flaticon-delete fw-normal text-primary icon-md"></span>
                                    </span>
                                    <span className="navi-text text-secondary">
                                        Borrar solicitud de documento  </span>
                                    <span className="navi-icon pull-right">
                                        <button className="btn btn-icon btn-light btn-xs bg-white">
                                            <i className="flaticon2-right-arrow text-primary icon-sm"></i>
                                        </button>
                                    </span>
                                </a>
                            </li> 
                            </>
                            )}
                            
                        </ul>
                    </div>
                </div>

            </div>
        );
    }
}

export default PendingDocumentsActions;

if (document.getElementById('PendingDocumentsActions')) {
    ReactDOM.render(<PendingDocumentsActions />, document.getElementById('PendingDocumentsActions'));
}
